<template>
  <div>
    <ul class="heading-ul mt-4 ml-10">
      <li>
        <router-link to="/leads_history" class="vx-row">
          <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          <h4>{{ $t("leads.label.create_lead") }}</h4>
        </router-link>
      </li>
    </ul>
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      stepSize="xs"
      shape="circle"
      finishButtonText="Submit"
      ref="wizard"
    >
      <tab-content
        :title="$t('leads.label.personal_details')"
        :icon="tabIndex > 0 ? 'feather icon-check' : ''"
      >
        <!-- tab 1 content -->
        <vx-card class="form-padding">
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
              <ul class="leftx flex mt-base">
                <h6>{{ $t("leads.label.Type") }}</h6>
                <li class="mr-2 ml-8">
                  <vs-radio
                    v-model="entity.prospectType"
                    vs-value="1"
                    color="success"
                    class=""
                    >{{ $t("leads.label.Individual") }}</vs-radio
                  >
                </li>

                <li class="mr-2 ml-8">
                  <vs-radio
                    v-model="entity.prospectType"
                    vs-value="2"
                    color="success"
                    class=""
                    >{{ $t("leads.label.Corporate") }}</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row mt-8">
            <div class="vx-col md:w-1/2 w-full">
              <h3>{{ $t("leads.label.personal_details") }}</h3>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col md:w-1/2 w-full mt-3">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("leads.label.BusinessEntityCode") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="business entity code"
                >
                  <vue-simple-suggest
                    v-model="loc"
                    :list="locationList"
                    @input="testMethod2()"
                    class="w-full font-normal mb-2"
                    :filter-by-query="true"
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span @click="changeLoc(suggestion.id)"
                        >
                        {{ suggestion.name }}</span
                      >
                    </div>
                  </vue-simple-suggest>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required|alpha"
                v-slot="{ errors }"
                name="first name"
              >
                <vs-input
                  :label="$t('leads.label.first_name')"
                  class="w-full mt-3 starlabel mb-3"
                  v-model="entity.firstName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input
                :label="$t('leads.label.middle_name')"
                class="w-full"
                v-model="entity.middleName"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required|alpha"
                v-slot="{ errors }"
                name="last name"
              >
                <vs-input
                  :label="$t('leads.label.last_name')"
                  class="w-full starlabel mb-3"
                  v-model="entity.lastName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-8">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors }"
                name="email id"
              >
                <vs-input
                  :label="$t('leads.label.email_id')"
                  class="w-full starlabel mb-3"
                  v-model="entity.email"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required|numeric|max:10|min:10"
                v-slot="{ errors }"
                name="mobile number"
              >
                <vs-input
                  :label="$t('leads.label.mobile_number')"
                  class="w-full starlabel mb-3"
                  v-model="entity.mobileNumber"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-8">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required|numeric|max:10|min:6"
                v-slot="{ errors }"
                name="office number"
              >
                <vs-input
                  :label="$t('leads.label.office_number')"
                  class="w-full starlabel mb-3"
                  v-model="entity.workPhoneNumber"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </tab-content>

      <tab-content
        :title="$t('leads.label.address_details')"
        :icon="tabIndex > 1 ? 'feather icon-check' : ''"
      >
        <vx-card class="form-padding">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <h3>{{ $t("leads.label.address_details") }}</h3>
            </div>
          </div>
          <div class="vx-row mt-8">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="address"
              >
                <vs-input
                  :label="$t('leads.label.address')"
                  class="w-full starlabel mb-3"
                  v-model="entity.address"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("leads.label.city_area")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="city/area"
                >
                  <v-select
                    label="city"
                    v-model="entity.city"
                    :options="addressTemplate.cityData"
                    placeholder="--Select Search--"
                    @input="getAddress"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input
                :label="$t('leads.label.street_area')"
                class="w-full"
                v-model="entity.streetArea"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="district"
              >
                <vs-input
                  :label="$t('District')"
                  class="w-full"
                  v-model="entity.district"
                  disabled
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-8">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="state"
              >
                <vs-input
                  :label="$t('leads.label.state')"
                  class="w-full"
                  v-model="entity.state"
                  disabled
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="country"
              >
                <vs-input
                  :label="$t('leads.label.country')"
                  class="w-full"
                  v-model="entity.country"
                  disabled
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-8">
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                rules="required|numeric|max:6"
                v-slot="{ errors }"
                name="zip code"
              >
                <vs-input
                  :label="$t('leads.label.zip_code')"
                  class="w-full starlabel mb-3"
                  v-model="entity.zipCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </tab-content>

      <tab-content
        :title="$t('leads.label.source_details')"
        :icon="tabIndex > 2 ? 'feather icon-check' : ''"
      >
        <vx-card class="form-padding">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <h3>{{ $t("leads.label.source_details") }}</h3>
            </div>
          </div>
          <div class="vx-row mt-8">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("leads.label.source")
                }}</small>
                <v-select
                  label="mCodeValue"
                  v-model="entity.sourceOfPublicity"
                  :options="prospectsTemplate.sourceOfPublicityData"
                  placeholder="--Select One--"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :reduce="(obj) => obj.mCodeValue"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("leads.label.service")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="service"
                >
                  <v-select
                    label="serviceCode"
                    v-model="entity.service"
                    :options="clientService.serviceData"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(obj) => obj.serviceCode"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("leads.label.next_call_date_time")
                }}</small>
                <flat-pickr
                  :config="configdateTimePicker"
                  class="w-full"
                  v-model="entity.preferredCallingTime"
                />
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("leads.label.note")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="note"
                >
                  <vs-textarea
                    class="w-full mb-2 font-semibold"
                    v-model="entity.note"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </tab-content>

      <tab-content
        :title="$t('leads.label.complete')"
        :icon="tabIndex > 3 ? 'feather icon-check' : ''"
      >
        <vx-card class="form-padding">
          <div style="height: 20px"></div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <img
                src="@/assets/images/pages/success.png"
                style="width: 400px"
              />
            </div>
          </vs-row>
          <div class="center success-msg">Lead Created Successfully</div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <vs-button @click="$router.push('/leads_history')">
                {{ $t("leads.label.go_back_to_leads_list") }}
              </vs-button>
            </div></vs-row
          >
        </vx-card>
      </tab-content>

      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left"></div>
        <div class="wizard-footer-right"></div>
        <div class="center">
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex == 0"
            type="border"
            @click="$router.push('/leads_history')"
            >{{ $t("leads.label.cancel") }}</vs-button
          >
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex > 0 && !props.isLastStep"
            @click.native="props.prevTab()"
            type="border"
            >{{ $t("leads.label.previous") }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 0"
            @click.native="validateOne()"
            :style="props.fillButtonStyle"
          >
            {{
              props.isLastStep ? $t("leads.label.done") : $t("leads.label.next")
            }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 1"
            @click.native="validateTwo()"
            :style="props.fillButtonStyle"
            >{{ $t("leads.label.next") }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 2"
            @click="createProspects"
            :style="props.fillButtonStyle"
            >{{ $t("leads.label.submit") }}</vs-button
          >
        </div>
      </template>
    </form-wizard>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueSimpleSuggest from "vue-simple-suggest";
import { ValidationProvider } from "vee-validate";

const entityEmptyObj = {
  address: "",
  city: "",
  country: "",
  district: "",
  email: "",
  firstName: "",
  lastName: "",
  locale: "en",
  middleName: "",
  mobileNumber: "",
  note: "",
  officeId: "",
  preferredCallingTime: moment().format("DD/MM/YYYY HH:mm:ss"),
  prospectType: "1",
  service: "",
  sourceOfPublicity: "",
  state: "",
  streetArea: "",
  zipCode: "",
  workPhoneNumber: "",
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      message: "Success",
      entity: entityEmptyObj,
      parentEntities: [],
      loc: "",
      errorMessage: "",
      city: "",
      tabIndex: 0,
      bulkUploads: {
        file: null,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d/m/Y H:i:s",
      },
    };
  },
  components: {
    Datepicker,
    flatPickr,
    FormWizard,
    TabContent,
    VueSimpleSuggest,
    "v-select": vSelect,
    ValidationProvider,
  },
  computed: {
    ...mapState({
      prospectsTemplate: (state) => state.leads.prospectsTemplate,
      addressTemplate: (state) => state.leads.addressTemplate,
      getAddressSearch: (state) => state.leads.getAddressSearch,
      clientService: (state) => state.leads.clientService,
      locationList: (state) => state.entity.locationList,
    }),
  },
  methods: {
    testMethod2() {
      let temp = this.loc;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);
        if (typeof temp === "object") {
          this.loc = temp.name;
          // this.loc = temp.externalId + "--" + temp.name;
          this.entity.officeId = temp.id;
        }
      } else {
        this.$store.dispatch("entity/entityGetLocationAction", this.loc);
      }
    },
    async validateOne() {
      if (
        !this.loc ||
        !this.entity.firstName ||
        !this.entity.lastName ||
        !this.entity.mobileNumber ||
        !this.entity.email ||
        !this.entity.workPhoneNumber
      ) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        this.nextTab();
      }
    },
    async validateTwo() {
      if (!this.entity.zipCode || !this.entity.address || !this.entity.city) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        this.warningText = "";
        this.nextTab();
      }
    },
    nextTab() {
      this.tabIndex = this.$refs.wizard.activeTabIndex + 1;
      this.$refs.wizard.nextTab();
    },
    async getProspectsTemplate() {
      try {
        await this.$store.dispatch("leads/setProspectsTemplate", this.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAddressTemplate() {
      try {
        await this.$store.dispatch("leads/setAddressTemplate", this.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAddress() {
      try {
        await this.$store.dispatch("leads/setAddress", this.entity.city);
        this.entity.country = this.getAddressSearch.country;
        this.entity.district = this.getAddressSearch.district;
        this.entity.state = this.getAddressSearch.state;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getclientservice() {
      try {
        await this.$store.dispatch("leads/fetchClientService", this.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createProspects() {
      if (
        !this.entity.service ||
        !this.entity.sourceOfPublicity ||
        !this.entity.preferredCallingTime ||
        !this.entity.note
      ) {
        this.warningPopup = true;
        this.errorMessage = "";
        this.warningText = "Fill the required fields!";
      } else {
        try {
          delete this.entity.openingDate;
          this.entity.locale = "en";
          this.entity.service = [this.entity.service];
          await this.$store.dispatch(
            "leads/createProspectsAction",
            this.entity
          );
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Lead Created Successfully!",
            type: "success",
          });
          this.nextTab();
          this.resetForm();
        } catch (e) {
          this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          );
          this.warningText = "";
          this.warningPopup = true;
          this.errors = e.message.errors;
        }
      }
    },
    resetForm() {
      this.entity = entityEmptyObj;
      this.entity.zipCode = "";
      this.entity.firstName = "";
      this.entity.lastName = "";
      this.entity.address = "";
      this.entity.middleName = "";
      this.entity.mobileNumber = "";
      this.entity.note = "";
      this.entity.address = "";
      this.entity.city = "";
      this.entity.country = "";
      this.entity.district = "";
      this.entity.email = "";
      this.entity.preferredCallingTime = "";
      this.entity.prospectType = "";
      this.entity.service = "";
      this.entity.sourceOfPublicity = "";
      this.entity.state = "";
      this.entity.streetArea = "";
      this.entity.workPhoneNumber = "";
    },
  },
  watch: {},
  mounted() {
    this.id = this.$route.params.id;
    this.getProspectsTemplate();
    this.getAddressTemplate();
    this.getclientservice();
  },
};
</script>
<style lang="scss">
.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  width: 42%;
  left: 45px;
}

@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";
.disabled-upload {
  display: none !important;
}
</style>
